import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { BOOKING_URL, CTA_LABEL } from '../data/constants';

const StickyCTA = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const nearEnd = window.innerHeight + window.scrollY > document.body.offsetHeight - 700;
      setVisible(window.scrollY > 900 && !nearEnd);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 140, damping: 20 }}
          className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-6 sm:bottom-6 z-40"
          data-testid="sticky-cta-bar"
        >
          <div className="glass-dark rounded-2xl sm:rounded-full shadow-2xl shadow-black/50 px-4 py-3 sm:pl-6 sm:pr-2 flex flex-col sm:flex-row items-center gap-3 sm:gap-6">
            <div className="hidden sm:block text-sm">
              <p className="text-white font-semibold leading-tight">Kandidat in 24h</p>
              <p className="text-slate-400 text-xs">7.999 € Festpreis · 0 € Risiko</p>
            </div>
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="btn-lux w-full sm:w-auto px-5 py-3 text-sm" data-testid="sticky-cta">
              <span className="whitespace-nowrap">{CTA_LABEL}</span>
              <ArrowRight className="w-4 h-4 flex-shrink-0" />
            </a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyCTA;
